import React from "react";
import PropTypes from "prop-types";
import GenericCard from "components/UI/GenericCard/GenericCard";
import DashedTooltip from "components/UI/DashedTooltip";
import { returnUpDownClassname } from "utils/helpers";

const EdgeCard = (props) => {
  const { metrics } = props.optionsResults;
  const {
    baselineRate,
    baselineSampleSize,
    edgeAbsolute,
    edgeLift,
    edgeLiftLow,
    edgeLiftHigh,
    zScore,
    pValue,
    isSignificant,
  } = metrics.edge;

  return (
    <GenericCard
      title="Edge vs. Baseline"
      tooltipText="Every symbol has its own 'normal' -- some move 7% in 3 bars routinely, some almost never. Baseline is this symbol's own unconditional hit rate for the same target/window on ANY random day (not just after a buy signal). Edge is how much better the signal does than that baseline -- the fast answer to 'is this actually worth trading, or just a volatile stock'."
    >
      <div>
        <h2 className={returnUpDownClassname(edgeAbsolute)}>
          {edgeAbsolute > 0 ? "+" : ""}
          {edgeAbsolute}pp
        </h2>
        <h5>
          edge over baseline ({metrics.successRate}% signal vs{" "}
          {baselineRate}% baseline, n={baselineSampleSize})
        </h5>
      </div>
      <div className="pt-2 flex gap-8">
        <div>
          <DashedTooltip text="Lift range derived from the Wilson confidence interval on the signal success rate -- a more honest statement than a single point estimate, since it shows how much that estimate could move with more data.">
            <h5>Lift</h5>
          </DashedTooltip>
          <h3>{edgeLift === null ? "N/A" : `${edgeLift}x`}</h3>
          {edgeLiftLow !== null && (
            <span className="text-xs">
              ({edgeLiftLow}x - {edgeLiftHigh}x)
            </span>
          )}
        </div>
        <div>
          <DashedTooltip text="Two-proportion z-test comparing signal success rate vs baseline. |z| > ~2 (p < 0.05) means the gap is unlikely to be random noise, given the sample sizes on both sides.">
            <h5>Significance</h5>
          </DashedTooltip>
          <h3 className={isSignificant ? "green" : "red"}>
            z={zScore} (p={pValue})
          </h3>
        </div>
      </div>
      <div className="pt-2">
        <span className={isSignificant ? "green" : "red"}>
          {isSignificant
            ? "Statistically significant edge"
            : "Not statistically significant yet"}
        </span>
      </div>
    </GenericCard>
  );
};

EdgeCard.propTypes = { optionsResults: PropTypes.object };

export default EdgeCard;
